<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="onReset()">
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "payment_control_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

@if (paymentElementField(); as field) {
    <sp-payment-method-signal
        [field]="field"
        [paymentMethods]="paymentMethods()"
        [paymentElements]="paymentElements()"
        (isInvalidChangeEvent)="isSaveDisabled.set($event)"
    />
}

<web-settings-footer [isSaveDisabled]="isSaveDisabled()" (saveEvent)="onSave()" (cancelEvent)="onReset()" />
